export const getUserTypeFromLocalStorage = () => {
	return localStorage.getItem("userType") ?? "General" 
};